import { render, staticRenderFns } from "./RateInput.vue?vue&type=template&id=c8ebf54a&scoped=true&"
import script from "./RateInput.vue?vue&type=script&lang=js&"
export * from "./RateInput.vue?vue&type=script&lang=js&"
import style0 from "./RateInput.vue?vue&type=style&index=0&id=c8ebf54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ebf54a",
  null
  
)

export default component.exports